import ProfileImg from '../img/Profile_Img.jpeg';

export const HomeData = [
    {
        image: ProfileImg,
        title: "what can i build for you?",
        messages: [ "Blog Page?", "Online Store?", "Small Business Site?"],
        blurb: "I specialize in responsive design and interactive UI"
    }
]